import React from 'react';
import {View} from 'react-native';
import {get} from 'lodash';

import Text from '/component/base/Text';
import {Reports} from '/constant/TestIDs';
import {ACCEPTDECLINE} from '/enum/candidates.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';
import {getDateUtilDefaultInstance} from '/util/date.util';

import {styles} from './AcceptByComponent.style';

interface AcceptByComponentProps {
  item: {
    acceptBefore: string;
    status: string;
  };
  tt: (keyPrefix: any, value: any) => void;
  reportName: string;
}

export const AcceptByComponent = ({
  item,
  tt,
  reportName,
}: AcceptByComponentProps) => {
  const acceptBefore = get(item, 'acceptBefore', '');
  const showDay = getDateUtilDefaultInstance().checkDate(
    acceptBefore,
    reportName,
  );
  const candidateAcceptByTime =
    getDateUtilDefaultInstance().getLocalTimeInHours(acceptBefore);
  const formattedAcceptByTime = candidateAcceptByTime?.replace(/^0+/, '');
  return (
    <View style={styles.acceptTimeContainer}>
      {item?.acceptBefore &&
        item?.status === ACCEPTDECLINE &&
        showDay &&
        tt(
          'candidateAcceptTime',
          generateComponentCallback({
            component: (
              <Text
                allowFontScaling
                maxFontSizeMultiplier={2}
                accessible={true}
                accessibilityLabel={`Accept by ${formattedAcceptByTime} CT ${showDay}`}
                variant="button"
                style={styles.acceptTimeText}
                testID={Reports.reportCandidateAcceptBy}>
                Accept by {formattedAcceptByTime} CT {showDay}
              </Text>
            ),
          }),
        )}
    </View>
  );
};

export default withTranslation('report.record.acceptByComponent')(
  AcceptByComponent,
);
